import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, STRING, UUID, ARRAY } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'notificationcampaign'

  static get fields () {
    return {
      id: new UUID(),
      zone: new STRING(),
      accounts: new ARRAY(),
      billing: new BOOLEAN(),
      carriers: new ARRAY(),
      greeting: new STRING(),
      message: new STRING(),
      reply_to: new STRING(),
      sender_name: new STRING(),
      subject: new STRING(),
      template: new STRING(),
      users: new BOOLEAN(),
      emails: new ARRAY()
    }
  }
}
